import React, {useState} from 'react';
import {Button, FormGroup, Label, Input} from 'reactstrap';

const tmsFields = [
    { field: 'tmsCinemaId', label: 'TMS Cinema ID', icon: 'fa-file' },
    { field: 'tmsRoomId', label: 'TMS Room ID', icon: 'fa-file' },
    { field: 'tmsPlayerId', label: 'TMS Player ID', icon: 'fa-file' },
    { field: 'tmsLMSId', label: 'TMS LMS id', icon: 'fa-file' },
    { field: 'tmsApiBaseUrl', label: 'TMS API base URL', icon: 'fa-link' },
    { field: 'masterDataApiBaseUrl', label: 'Master Data API Base Url', icon: 'fa-link' },
    { field: 'scsApiBaseUrl', label: 'SCS API Base Url', icon: 'fa-link' },
]

const TmsSettings = ({ initialSettings, onSave }) => {
    const [tmsSettings, setTmsSettings] = useState(initialSettings || {});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTmsSettings((prevSettings) => ({
            ...prevSettings,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(tmsSettings);
    };

    return (
        <div>
            <div>
                {tmsFields.map(({ field, label, icon }) => (
                    <FormGroup key={field}>
                        <Label for="field">
                            <span className={`fas me-2 fa-fw text-primary ${icon}`} title={label} />
                            {label}
                        </Label>
                        <Input
                            id={field}
                            name={field}
                            placeholder={label}
                            value={tmsSettings[field]}
                            onChange={handleChange}
                        />
                    </FormGroup>
                ))}
            </div>

            <div className="d-flex justify-content-end mt-3">
                <Button onClick={handleSubmit} color="primary">Save Changes</Button>
            </div>
        </div>
    );
};

export default TmsSettings;
